import { render, staticRenderFns } from "./MenuIframe.vue?vue&type=template&id=47d57340&scoped=true"
import script from "./MenuIframe.vue?vue&type=script&lang=js"
export * from "./MenuIframe.vue?vue&type=script&lang=js"
import style0 from "./MenuIframe.vue?vue&type=style&index=0&id=47d57340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d57340",
  null
  
)

export default component.exports